// extracted by mini-css-extract-plugin
module.exports = {"button":"jgp-1rS_G"};